import { Component, Injector } from '@angular/core';
import { CanvasLayoutDataService } from '../../../../submodules/angular-common/canvas-layout-data.service';
import { RoutingDataService } from '../../../../submodules/angular-common/routing-data.service';
import { BaseView } from '../../../../submodules/angular-ui-common/base-view';
import { PageLayoutDataService } from '../../../../submodules/angular-common/page-layout-data.service';


/**
 * Layout di base applicabile ad una page. 
 * Una page è una view che occupa l'intera area disponibile al netto delle side-nav, dell'header e dell'eventuale footer 
 * (il footer generalmente fa parte della page)
 */
@Component({ 
  selector: 'app-mobile-page-layout',
  templateUrl: './mobile-page-layout.component.html',
  styleUrls: ['./mobile-page-layout.component.scss']
})
export class MobilePageLayoutComponent extends BaseView {

  public routingDataService: RoutingDataService;
  public pageLayoutDataService: PageLayoutDataService;
  public canvasLayoutDataService: CanvasLayoutDataService;

  constructor(
    protected _injector: Injector
  ) {
    super(_injector)
    this.routingDataService = _injector.get(RoutingDataService)
    this.pageLayoutDataService = _injector.get(PageLayoutDataService)
    this.canvasLayoutDataService = _injector.get(CanvasLayoutDataService)
  }
}
